import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollTop from "../Scroll/ScrollTop";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Layout = (props) => {
  return (
    <>
      <Header />
      <main>
        {props.children}
        <ScrollTop {...props}>
          <Fab color="primary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
          </Fab>
        </ScrollTop>
      </main>
      <Footer />
    </>
  );
};

export default Layout;
